import CCForm from './component-form.js';
import { HideFormError, ShowFormError } from './component-form-functions.js';

class OversizedCoverForm extends CCForm {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this._submit = this._form.querySelector('button[type="submit"]');
        this._submit.addEventListener('click', (event) => {
            event.preventDefault();
            this.SubmitForm();
            window.scroll({ top: (this._section.getBoundingClientRect().top + window.scrollY - 100), left: 0, behavior: 'smooth' });
        });
    }

    SubmitForm() {
        if (!this.ValidateForm()) return;
        const inputs = Object.fromEntries([...this._inputs].map(input => ([input.name, (input.value || '').trim()])));
        const upgrades = [...this._form.querySelectorAll('input[name="upgrades[]"]:checked')].map(i => (i.value || '').trim()).filter(Boolean);
        const selectedLabel = (inputs.issue || '').trim();
        const coverModel = inputs['cover-model'] ? `Cover Model: ${inputs['cover-model']}\n\n` : '';

        fetch(this.dataset.submitUrl, {
          method: 'POST',
          headers: { 'Content-type': 'application/json' },
          body: JSON.stringify({
            request: {
              requester: { name: `${inputs['first-name']} ${inputs['last-name']}`, email: inputs['email'] },
              comment: {
                body:
                  `Phone number: ${inputs['phone']}\n\n` +
                  `Spa Make: ${inputs['spa-make']}\n\n` +
                  `Spa Model: ${inputs['spa-model']}\n\n` +
                  `Cover Length: ${inputs['cover-length']}\n\n` +
                  `Cover Width: ${inputs['cover-width']}\n\n` +
                  `Panels: ${inputs['panels']}\n\n` +
                  coverModel +
                  `Taper: ${inputs['taper']}\n\n` +
                  `Foam Density: ${inputs['foam-density']}\n\n` +
                  `Skirt Length: ${inputs['skirt-length']}\n\n` +
                  `Material: ${inputs['material']}\n\n` +
                  `Upgrades: ${upgrades.join(', ') || 'None'}\n\n` +
                  `Ship To ZIP Code: ${inputs['ship-to-zipcode']}`
              },
              subject: `Order: Oversize Quote Request`,
              custom_fields: [
                { 
                  "id": 35182567588628, value: "order__oversize_quote_request"
                },
                {
                  "id": 39169723830420, value: "sales_dealercx"
                },
                {
                  "id": 47615097208724, value: "general_inquiry_warrantycx_clone"
                }
              ]
            }
          })
        })
        .then(res => {
          if (res.ok) {
            this._sectionHeader.classList.add('hide');
            this._sectionHeaderConfirm.classList.remove('hide');
            this._form.classList.add('hide');
            this._formConfirmation.classList.remove('hide');
          } else {
            res.clone().text().then(raw => {
              try {
                const data = JSON.parse(raw);
                const details = {
                  error: data?.error,
                  description: data?.description,
                  details: data?.details
                };
                console.error('Zendesk request failed', {
                  status: res.status,
                  statusText: res.statusText,
                  ...details
                });
              } catch {
                console.error('Zendesk request failed (non-JSON body)', {
                  status: res.status,
                  statusText: res.statusText,
                  body: raw
                });
              }
            }).catch(e => {
              console.error('Failed to read error body', e);
            });

            HideFormError(this._formError);
            ShowFormError(this._formError, `${res.status}: ${res.statusText}`);
          }
        })
        .catch(err => {
          HideFormError(this._formError);
          ShowFormError(this._formError, err);
        })
    }
}

customElements.define('oversized-cover-form', OversizedCoverForm);